export default __webpack_public_path__ + "static/media/60_mobile.8acf162e.jpg";